import { ColorPool } from './ColorPool';

export const getOrCreatePool = (() => {
    const pools: { [key: string]: ColorPool } = {};
    return (name: string) => (pools[name] ??= new ColorPool());
})();
